import { render, staticRenderFns } from "./ProductUpgradesHeader.vue?vue&type=template&id=f92e6776&scoped=true&"
import script from "./ProductUpgradesHeader.vue?vue&type=script&lang=js&"
export * from "./ProductUpgradesHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductUpgradesHeader.vue?vue&type=style&index=0&id=f92e6776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92e6776",
  null
  
)

export default component.exports